/* eslint-disable no-nested-ternary */

import EmptyContent from '@/commons/empty-content/EmptyContent';
import { translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import { Box, Card, CardProps, Stack } from '@mui/material';

interface Props extends CardProps {
  title: string;
  isOpen?: boolean;
  data: any;
}

export default function DiferenceCashRegister({ title, isOpen, data, sx, ...other }: Props) {
  const {
    difference_cash: differenceCash,
    difference_creditCard: differenceCreditCard,
    difference_transference: differenceTransference,
  } = data;

  return (
    <Card
      sx={{
        p: 3,
        height: '100%',
        borderRadius: 2,
        backgroundColor: 'common.white',
        ...sx,
      }}
      {...other}
    >
      <Stack>
        <div>
          <Box sx={{ mb: 1, typography: 'subtitle2' }}>{title}</Box>
        </div>
        {isOpen ? (
          <EmptyContent
            heighImage={100}
            mbImage={0}
            spacingStack={[3, 2]}
            title={translates.noData}
          />
        ) : (
          <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>Efectivo</span>
              <span style={{ fontSize: 'small' }}>{currentFormat(differenceCash ?? 0)}</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>Datafono</span>
              <span style={{ fontSize: 'small' }}>{currentFormat(differenceCreditCard ?? 0)}</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span>Transferencia</span>
              <span style={{ fontSize: 'small' }}>
                {currentFormat(differenceTransference ?? 0)}
              </span>
            </div>
          </>
        )}
      </Stack>
      {/* {
          JSON.stringify(data)
        } */}
    </Card>
  );
}
